import {OverlayContainer} from "../../../misc/ImageViewer";
import React, {useEffect, useRef, useState} from "react";
import SchemaEditContainer from "../SchemaEditContainer";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {BackTableFilter, PHP_TYPE_MAP, PhpType, setBackTableFilter} from "../../../../features/schemaManageSlice";
import styled from "styled-components";
import {OpsCategories, SqlOperation, SqlOperationInfo} from "../../../../Types";


type PropsI = {
    closeEditing: () => void,
    addNew?: boolean,
    filterKey: string,
    filter: BackTableFilter,
};
export default function EditFilter({closeEditing, addNew = false, filterKey, filter}: PropsI) {
    const tableName = useAppSelector(state => state.schemaManage.back.selectedTable) as string;
    const table = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName])!;
    const [newValue, setNewValue] = useState(filter)
    const [name, setName] = useState(filterKey)
    const dispatch = useAppDispatch();
    const deleteOps = (ops: SqlOperation[]) => setNewValue(prevState => ({
        ...prevState,
        operationsList: prevState.operationsList!.filter(o => !ops.includes(o))
    }));

    const addBackTableFilterOps = (ops: SqlOperation[]) => setNewValue(prevState => ({
        ...prevState,
        operationsList: prevState.operationsList ? Array.from(new Set(prevState.operationsList.concat(ops))) : [...ops]
    }));

    const fields = Object.keys(table.fieldsList);
    const filters = Object.keys(ethereal.filtersList);
    const availableFields = fields.filter(f => !filters.includes(f));

    useEffect(() => {
        if (addNew && availableFields.length > 0)
            setName(availableFields[0])
    }, [addNew, availableFields]);

    if (addNew && availableFields.length === 0)
        return <OverlayContainer $isVisible>
            <SchemaEditContainer>
                <div>ВСІ ПОЛЯ ДЛЯ ФІЛЬТРІВ ВЖЕ ЗАСТОСОВАНІ</div>
                <div>
                    <button className="close btn-cmn" onClick={closeEditing}>
                        ❌
                    </button>
                </div>
            </SchemaEditContainer></OverlayContainer>


    return <OverlayContainer $isVisible>
        <SchemaEditContainer>
            <Container>
                <div>{addNew ? "Створити" : "Редагувати"} фільтр {name}</div>
                {addNew && <div>
                    <select name="keys" id="keys" value={name} onChange={e => setName(e.target.value)}>
                        {availableFields.map(f => <option value={f} key={f}>{f}</option>)}
                    </select>
                </div>}
                <div>Тип:</div>
                <select name="type" id="type" value={newValue.type}
                        onChange={e => setNewValue(prevState => ({...prevState, type: (e.target.value as PhpType)}))}>
                    {Object.entries(PHP_TYPE_MAP).map(([key, value]) => <option value={key}
                                                                                key={key}>{value.desc}</option>)}
                </select>
                <div>
                    <label>Alias</label>
                    <input
                        type="checkbox"
                        checked={newValue.appendAlias !== false}
                        onChange={(e) => {
                            setNewValue(prevState => ({...prevState, appendAlias: e.target.checked}))
                        }}
                    />
                </div>
                <div>
                    <label>Outer</label>
                    <input
                        type="checkbox"
                        checked={!!newValue.outer}
                        onChange={(e) => {
                            setNewValue(prevState => ({...prevState, outer: e.target.checked}))
                        }}
                    />
                </div>
                <FilterOpsTable>
                    <thead>
                    <tr>
                        <th>Група</th>
                        <th>Усі</th>
                        <th>Операції</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Object.entries(OpsCategories).map(([group, ops]) =>
                        <tr key={group}>
                            <td className="group-name">{group}</td>
                            <td>
                                <input
                                    type="checkbox"
                                    checked={(ops as readonly SqlOperation[]).every(
                                        (op) => newValue.operationsList.includes(op)
                                    )}
                                    onChange={(e) => {
                                        if (e.target.checked)
                                            addBackTableFilterOps([
                                                ...OpsCategories[group as keyof typeof OpsCategories],
                                            ]);
                                        else {
                                            deleteOps([
                                                ...OpsCategories[group as keyof typeof OpsCategories],
                                            ]);
                                        }
                                    }}
                                />
                            </td>
                            <td className={'ops-td'}>
                                <table className="ops">
                                    <tbody>
                                    {(ops as readonly SqlOperation[]).map((op) => <tr key={op} className="op">
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={newValue.operationsList.includes(op)}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        addBackTableFilterOps([op]);
                                                    } else {
                                                        deleteOps([op]);
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td>{SqlOperationInfo[op].sql}</td>

                                    </tr>)}
                                    </tbody>
                                </table>
                            </td>
                        </tr>)}
                    </tbody>
                </FilterOpsTable>

                {!addNew && <div className="delete-field">
                    <button className={'btn-cmn'} onClick={() => {
                        dispatch(setBackTableFilter({
                            table: tableName,
                            filterKey: filterKey,
                            value: undefined
                        }))
                        closeEditing()
                    }}>
                        Видалити це поле
                    </button>
                </div>}
                <div className={'controls'}>
                    <button className={'save btn-cmn'} onClick={() => {
                        if (addNew && ethereal && ethereal.filtersList[name]) {
                            alert("Фільтр з таким ключем вже є! Змініть ключ")
                            return
                        }
                        dispatch(setBackTableFilter({
                            table: tableName,
                            filterKey: name,
                            value: newValue
                        }))
                        closeEditing()
                    }}>
                        Зберегти
                    </button>
                    <button className="close btn-cmn" onClick={closeEditing}>
                        ❌
                    </button>
                </div>
            </Container>
        </SchemaEditContainer>
    </OverlayContainer>

}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: .5rem;

    .delete-field {
        display: flex;
        gap: .5rem;
        flex-wrap: wrap;
        align-items: center;
    }

    //.filter-ops {
    //    display: flex;
    //    flex-flow: column;
    //    gap: .5rem;
    //
    //    .op-group-row {
    //        display: flex;
    //        flex-wrap: wrap;
    //        gap: .5rem;
    //
    //        .ops {
    //            display: flex;
    //            flex-wrap: wrap;
    //            gap: .5rem;
    //        }
    //    }
    //}

`

export const FilterOpsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    //border: 2px solid var(--table-border-color);
    font-family: sans-serif;
    font-size: 1rem;
    color: var(--table-row-text-color);

    th {
        background-color: var(--table-header-bg-color);
        color: var(--table-header-text-color);
        padding: 0.5rem;
        text-align: left;
        //border: 1px solid var(--table-border-color);
    }

    td {
        padding: 0.5rem;
        //border: 1px solid var(--table-border-color);
        vertical-align: top;
    }

    .ops-td {
        padding: 0;
        background-color: #001973;
        color: #dadff4;
    }

    //tbody tr:nth-child(odd) {
    //    background-color: var(--table-row-odd-bg-color);
    //}
    //
    //tbody tr:nth-child(even) {
    //    background-color: var(--table-row-even-bg-color);
    //}

    input[type="checkbox"] {
        accent-color: var(--table-action-color);
        cursor: pointer;
    }

    .group-name {
        font-weight: 600;
        color: var(--table-row-text-color);
        //padding: 0;
    }

    .ops {
        width: 100%;
        border-collapse: collapse;

        td {
            border: none;
            padding: 0.25rem 0.5rem;
        }

        .op {
            font-weight: bold;
            white-space: nowrap;
        }

        .op td:first-child {
            width: 2rem;
        }
    }
`;
